/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiagLabInventoryInvestigation from './diag-lab-inventory-investigation';
import DiagLabInventoryInvestigationDetail from './diag-lab-inventory-investigation-detail';
import DiagLabInventoryInvestigationUpdate from './diag-lab-inventory-investigation-update';
import DiagLabInventoryInvestigationDeleteDialog from './diag-lab-inventory-investigation-delete-dialog';

const DiagLabInventoryInvestigationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiagLabInventoryInvestigation />} />
    <Route path="new" element={<DiagLabInventoryInvestigationUpdate />} />
    <Route path=":id">
      <Route index element={<DiagLabInventoryInvestigationDetail />} />
      <Route path="edit" element={<DiagLabInventoryInvestigationUpdate />} />
      <Route path="delete" element={<DiagLabInventoryInvestigationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiagLabInventoryInvestigationRoutes;
